document.addEventListener("DOMContentLoaded", function() {
    var checkboxes = document.querySelectorAll(".collection-toggle");
    
    // 默认第一个复选框被选中
    checkboxes[0].checked = true;
    
    checkboxes.forEach(function(checkbox) {
        checkbox.addEventListener("change", function() {
            // 当其他复选框被选中时，之前被选中的复选框变为未被选中
            checkboxes.forEach(function(cb) {
                if (cb !== checkbox) {
                    cb.checked = false;
                }
            });
        });
    });
});
